export default [
  {
    path: '/companies',
    component: () => import('./Companies.vue'),
    children: [
      {
        path: '/',
        name: 'companiesList',
        component: () => import('./CompaniesList.vue')
      },
      {
        path: 'change',
        name: 'changeCompany',
        component: () => import('./ChangeCompany.vue')
      },
      {
        path: 'add',
        name: 'addCompany',
        component: () => import('./companies-form/CompanyForm.vue')
      },
      {
        path: ':id/edit',
        name: 'editCompany',
        component: () => import('./companies-form/CompanyForm.vue')
      },
      {
        path: ':id',
        name: 'companyDetails',
        component: () => import('./CompanyDetails.vue')
      }
    ]
  }
]
